import Axios from 'axios'
import { CONTENT_API, CONTENT_PREVIEW } from './Configuration'
import { CategoryPageBannerContentfulResponse } from '@/types'
import { error } from './Log'
interface SlugQueryProps {
  type: string
  id?: string,
  slug?: string
  preview?: boolean
}
const getContentWithSlug: <T>(s: SlugQueryProps) => Promise<T | null> = async <T>({ type, id = '', slug = id, preview = true }) => {
  let contentWithSlug: T| null = null
  const url = `${CONTENT_API}/content/${type}/${slug}${preview ? '?preview=true' : ''}`
  try {
    contentWithSlug = (await Axios.get<T>(url))?.data
  } catch (err) {
    error('Failed to fetch content with Slug from Contentful', { url, type, slug, CONTENT_API })
  }
  console.log(`contentWithSlug `, { contentWithSlug })
  return contentWithSlug
}

export const getContentWithoutSlug: <T>(type: string) => Promise<T> = async (type) => (await Axios.get(`${CONTENT_API}/content/${type}`, { params: { preview: CONTENT_PREVIEW } })).data

export default {
  categoryPage: ({ id }) => getContentWithSlug<CategoryPageBannerContentfulResponse>({ type: 'categoryPage', slug: id }),
  getContentWithSlug,
}
